var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    { staticClass: "w-message-box", attrs: { tag: "div", name: "fade" } },
    _vm._l(_vm.notices, function(notice, noticeIndex) {
      return _c(
        "div",
        {
          key: noticeIndex,
          staticClass: "w-message-main",
          class: ["w-message-" + notice.type],
          style: notice.style
        },
        [
          _c("p", { staticClass: "w-message-text" }, [
            _vm._v(_vm._s(notice.content))
          ])
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-899d64c8", { render: render, staticRenderFns: staticRenderFns })
  }
}